export type Pair = "HYPE" | "MERKLE" | "KNTQ" | "NVDAx";
export const descriptionLimit = 2000;
export const descriptionBytes = (text: string) => new TextEncoder().encode(text.trim()).length;
export const emptyDraft = {
  exemptWallets: "", name: "", ticker: "", description: "", x: "", telegram: "", website: "", devBuy: "", pair: "HYPE" as Pair,
};
export type Draft = Omit<typeof emptyDraft, "exemptWallets"> & { exemptWallets?: string };
export type TextField = Exclude<keyof Draft, "pair">;
export type EditField = (field: TextField, value: string) => void;

export function readDraft(draft: Draft): Draft {
  return { exemptWallets: draft.exemptWallets ?? "", name: draft.name.trim(), ticker: draft.ticker.trim(), description: draft.description.trim(),
    x: draft.x, telegram: draft.telegram, website: draft.website, devBuy: draft.devBuy.trim(), pair: draft.pair };
}

export function validateDraft(input: Draft): Partial<Record<TextField, string>> {
  const draft = readDraft(input);
  const errors: Partial<Record<TextField, string>> = {};
  if (!draft.name) errors.name = "Enter a name.";
  if (!draft.ticker) errors.ticker = "Enter a ticker.";
  if (descriptionBytes(draft.description) > descriptionLimit) errors.description = "Use at most 2,000 UTF-8 bytes.";
  if (draft.devBuy && (!/^\d+(\.\d{1,18})?$/.test(draft.devBuy) || !/[1-9]/.test(draft.devBuy))) {
    errors.devBuy = "Enter a positive HYPE amount with up to 18 decimal places.";
  }
  return errors;
}
